'use client'

import React from 'react'

type Props = {
    radius: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function ConeChart({ radius, height }: Props) {
    const maxDim = Math.max(radius * 2, height, 0.0001)
    const scale = 140 / maxDim
    const rx = Math.max(radius * scale, 28)
    const ry = rx * 0.32
    const h = Math.max(height * scale, 40)

    const cx = WIDTH / 2
    const baseY = (HEIGHT + h) / 2 - 10
    const apexY = baseY - h

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* body */}
            <polygon points={`${cx - rx},${baseY} ${cx},${apexY} ${cx + rx},${baseY}`} fill="#2563eb" opacity={0.2} />
            <line x1={cx - rx} y1={baseY} x2={cx} y2={apexY} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx + rx} y1={baseY} x2={cx} y2={apexY} stroke="#2563eb" strokeWidth={2} />
            {/* base ellipse */}
            <ellipse cx={cx} cy={baseY} rx={rx} ry={ry} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            {/* height marker (dashed to apex) */}
            <line x1={cx} y1={baseY} x2={cx} y2={apexY} stroke="#16a34a" strokeWidth={1.5} strokeDasharray="4,3" />
            <text x={cx + 6} y={(baseY + apexY) / 2} fontSize={11} textAnchor="start" fill="#16a34a">h = {height.toFixed(2)}</text>
            {/* radius marker */}
            <line x1={cx} y1={baseY} x2={cx + rx} y2={baseY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + rx / 2} y={baseY + 18} fontSize={11} textAnchor="middle" fill="#dc2626">r = {radius.toFixed(2)}</text>
        </svg>
    )
}
